export default function BottomCta() {
  return (
    <section className="w-full bg-secondary py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-black text-white mb-4">
          Broken Hardware? We Fix It Same Day
        </h2>
        <p className="text-sm md:text-base text-[#fefce8] max-w-[720px] mx-auto mb-8">
          Call for a free phone quote. Most hardware repairs handled within hours.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="tel:+17863774452"
            className="inline-flex items-center gap-2 bg-[#ea580c] text-white px-8 py-3 text-sm font-bold rounded-lg hover:bg-[#c2410c] transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line" />
            Call (786) 377-4452
          </a>
          <a
            href="mailto:contact@impact-window-repair-miami.com"
            className="inline-flex items-center gap-2 bg-transparent border-2 border-white text-white px-8 py-3 text-sm font-bold rounded-lg hover:bg-white hover:text-secondary transition-colors whitespace-nowrap"
          >
            <i className="ri-mail-line" />
            Email Windows and Doors Repair Miami
          </a>
        </div>
      </div>
    </section>
  );
}